import { formatNumber } from '@/lib/formatter';
import { getDeprecatedEventLabel } from '../utils/mapHelper';

const dateCell = (key, dateFormat) => ({
  key,
  formatter: (row) => (row[key] ? dateFormat(row[key]) : '-')
});

const satangCell = (key) => ({
  key,
  formatter: (row) => formatNumber((row[key] ?? 0) / 100, 0)
});

const defaultFormatter = (key) => (row) => row[key] || '-';

export function buildEarnCoinHeaders(dateFormat) {
  const headers = [
    { label: "ไอดีลูกค้า", key: "user_id", width: '80px' },
    { label: "ชื่อกระเป๋า", key: "user_wallet_id", width: '80px' },
    { label: "ชื่อลูกค้า", key: "mnc_recipient_name", width: '160px' },
    { label: 'เบอร์โทรศัพท์', key: 'mobile_number', width: '100px' },
    { label: 'อีเมล', key: 'email', width: '160px' },
    { label: 'สถานะลูกค้า', key: 'user_home_status', width: '80px' },
    { label: 'ที่อยู่', key: 'home_address_no', width: '80px' },
    { label: "รหัสโครงการ", key: 'project_code' },
    { label: 'รหัสพนักงาน', key: 'employee_id' },
    { label: "วันที่ได้รับ MNC", width: '100px', ...dateCell('mnc_received_date', dateFormat) },
    { label: "จำนวนที่ได้รับ MNC (MNC)", width: '120px', ...satangCell('mnc_received_amount') },
    { label: "จำนวนได้รับ MNC (บาท)", width: '110px', ...satangCell('mnc_received_value') },
    {
      label: "Event ที่ได้รับ MNC",
      key: 'mnc_event_name',
      width: '180px',
      formatter: ({ mnc_event: mncEvent, mnc_event_name: mncEventName }) => (
        mncEventName || getDeprecatedEventLabel(mncEvent)
      )
    },
    { label: 'ปีของ MNC ที่ได้รับ', key: 'mnc_year', width: '110px' },
    { label: "สถานะการทำรายการ", key: 'transaction_status' },
    { label: "MNC Expired", ...dateCell('expired_date', dateFormat) },
  ];

  return headers.map((header) => (
    header.formatter
      ? header
      : { ...header, formatter: defaultFormatter(header.key) }
  ));
}
